// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip-module--tooltip--o4xwi","tooltip--show-on-small-screen":"Tooltip-module--tooltip--show-on-small-screen--zixhQ"};